import type { PayslipImportedContent } from "@cyh/contracts";
import { useLanguage } from "../i18n";

export function PayslipFields({ content }: { content: PayslipImportedContent }) {
  const { t } = useLanguage();
  return <div className="payslip-import-preview"><h3>{content.title}</h3><div className="payslip-net"><span>{t("实发金额（CNY）", "Net pay (CNY)")}</span><strong>{content.net || "—"}</strong></div>
    {content.fields.map((field, index) => <div key={field.key}>{field.group && field.group !== content.fields[index - 1]?.group && <h4>{field.group}</h4>}<div className="payslip-field"><span>{field.label}</span><span>{field.value || "—"}</span></div></div>)}
  </div>;
}
